module.exports = __webpack_public_path__ + "static/bg-tattoo-8f6965375bd82714375fa8ad41878110.png";